import { ref } from 'vue'
import { defineStore } from 'pinia'

export const usePromoStore = defineStore('promo', () => {
  const promoTypes = ref([])
  const isShowBigWins = ref(null)

  function setPromoTypes(payload) {
    promoTypes.value = payload
  }

  function setIsShowBigWins(payload) {
    isShowBigWins.value = payload
  }

  return {
    // refs
    promoTypes,
    isShowBigWins,
    // computed

    //functions
    setPromoTypes,
    setIsShowBigWins,
  }
})
